import { action, computed, observable, makeObservable } from 'mobx';
import type { SelectInputOption } from '../../components/input/input.select';
import { CurrentState } from '../../state/page.state';
import { AppStore } from '../../store';

export interface AllStatuses {
	collectionId: string;
	statuses: string[];
	statusFieldId: string;
}

interface StatusOptionValue {
	value?: string;
	options?: { values?: StatusOptionValue[] };
}

export class StatusSelectorCtrl {
	@observable selectedStatus: string | null = null;
	allStatuses: AllStatuses[];
	loading: boolean = true;

	constructor() {
		makeObservable(this);
	}

	@computed get loadingStatuses(): boolean {
		return this.loading;
	}

	@computed get statusOptions(): SelectInputOption[] {
		this.loading = true;
		const options: SelectInputOption[] = [];
		const allCollectionStatuses = [];

		for (const summary of CurrentState.Tag.collections) {
			const collectionStatuses: string[] = [];
			const formSummary = AppStore.FormSummary.get(summary.formRevision);
			if (formSummary != null && formSummary.metadata != null && formSummary.metadata.status != null) {
				const form = AppStore.Form.get(formSummary.revision);
				if (form != null && form !== undefined && form.metadata != null) {
					for (const value of form.metadata.getStatusField().options.values) {
						const values = this.getAllValuesFrom(value);
						values.forEach((option) => {
							options.push({ key: option, value: option });
							collectionStatuses.push(option);
						});
					}

					allCollectionStatuses.push({
						collectionId: summary.objectId,
						statuses: collectionStatuses,
						statusFieldId: form.metadata.statusFieldId,
					});
				}
			}
		}

		this.allStatuses = allCollectionStatuses;
		this.loading = false;

		return this.uniqueOptions(options);
	}

	@action selectStatus(status?: string) {
		this.selectedStatus = status;
	}

	private getAllValuesFrom(value: StatusOptionValue): string[] {
		const values = [];
		if (value.options && value.options.values) {
			for (const option of value.options.values) {
				if (option.options && option.options.values) {
					for (const optionThirdLevel of option.options.values) {
						if (optionThirdLevel.value) {
							values.push(value.value + ' > ' + option.value + ' > ' + optionThirdLevel.value);
						}
					}
				} else {
					if (option.value) {
						values.push(value.value + ' > ' + option.value);
					}
				}
			}
		} else {
			if (value.value) {
				values.push(value.value);
			}
		}

		return values;
	}

	private uniqueOptions(options: SelectInputOption[]) {
		const seen: { [key: string]: boolean } = {};
		return options.filter(function (item) {
			return seen.hasOwnProperty(item.value) ? false : (seen[item.value] = true);
		});
	}
}
